import { PageHero } from "@/components/hero/PageHero";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";

export function HIPAANotice() {
  return (
    <div className="flex min-h-screen flex-col bg-bg text-ink">
      <Header />
      <main className="flex-1">
        <PageHero
          eyebrow="HIPAA notice"
          title="How Revetra handles your health information."
          subtitle="The short version: encrypted in transit and at rest, never used to train AI, and automatically deleted within 24 hours."
          size="sm"
        />
        <section className="bg-bg py-20">
          <div className="wrap max-w-3xl space-y-6 text-sm leading-relaxed text-muted">
            <p>
              Revetra is a drafting tool that processes information you choose to upload —
              typically a denial letter and, optionally, a portion of your medical record. We are
              not a covered entity under HIPAA, but we treat your information with the same care a
              covered entity would apply.
            </p>
            <h2 className="font-heading text-lg font-bold text-ink">What we do</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>Encrypt all uploads in transit (TLS) and at rest (object-storage encryption).</li>
              <li>
                Automatically delete your uploaded documents and the data extracted from them
                within 24 hours, on a fixed schedule — so nothing lingers on our servers.
              </li>
              <li>
                Process your documents only to draft your appeal, using trusted AI service providers
                bound by strict contractual terms that prohibit them from training on, retaining, or
                reusing your content.
              </li>
              <li>
                Limit access to your information to the minimum needed to run the service, and
                monitor for unauthorized access.
              </li>
            </ul>
            <h2 className="font-heading text-lg font-bold text-ink">What we don’t do</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>Require an account or a password.</li>
              <li>Sell, share, or rent your information.</li>
              <li>
                Use your documents to train AI models — ours or anyone else’s. (If you choose to
                tell us how your appeal turned out, we use that anonymized outcome — success or
                not — to improve the service; it contains no documents and no identifying
                details.)
              </li>
              <li>Retain your documents beyond the 24-hour window.</li>
              <li>
                Provide medical or legal advice. Revetra is a drafting aid, not a clinician or
                attorney.
              </li>
            </ul>
            <h2 className="font-heading text-lg font-bold text-ink">If something goes wrong</h2>
            <p>
              No system is perfectly secure, but we take protecting your information seriously. In
              the unlikely event of a security incident that affects your data, we will notify
              affected users without undue delay, as required by applicable law.
            </p>
            <h2 className="font-heading text-lg font-bold text-ink">Your rights and choices</h2>
            <p>
              You can end your session at any time by closing the tab, and you can request earlier
              deletion of your data through the help link in your session. We never sell your
              information. Depending on where you live — for example, California or Washington — you
              may have additional rights over your health data, including the right to access or
              delete it; contact us through the help center to exercise them. For more detail, see
              our Privacy Policy and Terms.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
